import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import DOMPurify from "dompurify";

interface AwardProps {
  award: AwardInterface;
  disabled: boolean;
  handleClick: any;
  selected: boolean;
}

interface AwardInterface {
  id: string;
  giverId: string;
  reason: string;
  sanitizedReason: string;
  giverFirstName: string;
  disabled: boolean;
  approval_required: boolean;
}

export default class Award extends React.Component<AwardProps, any> {
  render() {
    return (
      <div
        className={this.getClasses()}
        data-award-id={this.props.award.id}
        data-title={i18n.translate("awards.not_enough_budget")}
        onClick={this.props.handleClick.bind(this, this.props.award)}
      >
        <span className="reason">
          <span>
            {this.props.award.giverFirstName}
            :&nbsp;
          </span>
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(this.props.award.sanitizedReason),
            }}
          />
        </span>
      </div>
    );
  }

  getClasses = () => {
    let classes = "award-holder";
    if (this.props.disabled) {
      classes += " disabled tooltip-container";
    }
    if (this.props.selected) {
      classes += " selected";
    }
    return classes;
  };
}
